import { render, staticRenderFns } from "./form-setup.html?vue&type=template&id=202d9f1c&scoped=true&"
import script from "./FormSetup.vue?vue&type=script&lang=js&"
export * from "./FormSetup.vue?vue&type=script&lang=js&"
import style0 from "./FormSetup.vue?vue&type=style&index=0&id=202d9f1c&scoped=true&lang=css&"
import style1 from "./FormSetup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202d9f1c",
  null
  
)

export default component.exports